export const CALCULATION_DETAILS_DRAWER = {
    'CALCULATION.DETAILS.DRAWER.TITLE': 'Detalii calcul',
    'CALCULATION.DETAILS.DRAWER.CLIENT_NAME': 'Nume client:',
    'CALCULATION.DETAILS.DRAWER.COMPANY_NAME': 'Nume companie:',
    'CALCULATION.DETAILS.DRAWER.CALCULATION_SPAN': 'Perioadă calcul:',
    'CALCULATION.DETAILS.DRAWER.DOCUMENTS_ACTIONS': 'Acțiuni documente:',
    'CALCULATION.DETAILS.DRAWER.CALCULATION_HISTORY_LOGS': 'Istoric:',
    'CALCULATION.DETAILS.DRAWER.ACTION.DOWNLOAD_REPORT': 'Descarcă declarația',
    'CALCULATION.DETAILS.DRAWER.ACTION.DOWNLOAD_RECORD_BOOK': 'Descarcă registru de evidență',
    'CALCULATION.DETAILS.DRAWER.ACTION.DOWNLOAD_BALANCE': 'Descarcă balanța'
};
